import { c as _c } from "react/compiler-runtime";
import { TrialCountdownIndicator } from "@components/sidebar/trial-countdown/trial-countdown-indicator";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { ListItemButton } from "@flat-ui";
import { MainRoutes, SettingsTabs } from "@router/route-params";
import { DateTimeUtils } from "@stellar/utils";
import { topPriorityXgSubscriptionSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { isTrialSubscription } from "@utils/subscription-utils";
import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Shows the remaining days of a trial subscription */
export function TrialCountdown() {
  const $ = _c(5);
  const subscription = useAppSelector(topPriorityXgSubscriptionSelector);
  const {
    canViewSubscriptionDetails
  } = useHasUserValidRoleCompanyLevel();
  const isTrial = isTrialSubscription(subscription);
  let t0;
  bb0: {
    if (!subscription || !isTrial) {
      t0 = undefined;
      break bb0;
    }
    const expirationDate = subscription.endDate;
    let t1;
    if ($[0] !== expirationDate) {
      t1 = DateTimeUtils.diffFromTodayInDays({
        date: expirationDate,
        shouldIncludeToday: false
      });
      $[0] = expirationDate;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const diffFromTodayInDays = t1;
    t0 = diffFromTodayInDays > 0 ? diffFromTodayInDays : 0;
  }
  const remainingDays = t0;
  if (remainingDays === undefined) {
    return null;
  }
  let t1;
  if ($[2] !== canViewSubscriptionDetails || $[3] !== remainingDays) {
    t1 = canViewSubscriptionDetails ? <NavLink to={`${MainRoutes.settings}/${SettingsTabs.subscription}`} style={{
      textDecoration: "none"
    }}><ListItemButton sx={{
        padding: 0,
        "&:hover": {
          color: "primary.main",
          fill: PALETTE_VARS.primary.main
        }
      }}><TrialCountdownIndicator remainingDays={remainingDays} /></ListItemButton></NavLink> : <TrialCountdownIndicator remainingDays={remainingDays} />;
    $[2] = canViewSubscriptionDetails;
    $[3] = remainingDays;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}